import axios from "axios";
import { Carousel, Modal, Table } from "antd";
import { useDebounce } from "hooks";
import { useRecoilState } from "recoil";
import { useEffect, useRef, useState } from "react";
import { UserListIcon, SearchIcon, UsersListIcon, AddUserIcon } from "icons";
import { userListPagination, userListSearch } from "store/atom";
import { userListPagination2 } from "store/atom";
import { userListColumns } from "./constants";
import styles from "./style.module.scss";
import { ConditionalRenderer } from "components";
import { AddUserModal } from "../addUserModal";
import { ReactComponent as NextIcon } from "icons/sliderNextIcon.svg";
import { ReactComponent as PreviousIcon } from "icons/sliderPreviousIcon.svg";
import { GeographicalUserInsights } from "../geographical-insights-list";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";
import { UseLazyApiCallInternalDashboard } from "pages/internal-dashboard/hooks/use-lazy-api-call";
import { UseLazyApiCallOldDashboard } from "hooks/use-lazy-api-call-old-dashboard";
import { UserDetailModalV2 } from "../userDetailModalV2";
import { useLocation, useNavigate } from "react-router-dom";
import { AddUserModalV2 } from "../addUserModalV2";

export function UserList({
  setShowUserSubscDetailModal,
  maxHeight,
  setUserInfo,
  userInfo,
  showUserSubscDetailModal,
  handleCloseModal,
}) {
  const { searchParams } = useLocation;
  const queryParams = new URLSearchParams(window.location.search);

  const strikerIdStr = queryParams.get("strikerId");
  const strikerId = strikerIdStr ? JSON.parse(strikerIdStr) : null;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openAddUser, setOpenAddUser] = useState(false);
  const [userSearch, setUserSearch] = useRecoilState(userListSearch);
  const [pagination, setPagination] = useRecoilState(userListPagination2);
  const deboucedSearch = useDebounce(userSearch, 500);
  const [currentSlide, setCurrentSlide] = useState(0);

  const sliderRef = useRef();

  const [getUsersData, { data: usersData, isLoading, error }] =
    UseLazyApiCallOldDashboard({
      url: "get_all_users",
      method: "POST",
    });

  async function getUsers({ page, size, order = "", name = "", search }) {
    const payload = {
      page,
      size,
      search,
      order,
      name,
    };

    const response = await getUsersData({
      params: payload,
    });

    const dataRes = response?.users;
    const extraObjData = {
      role: "",
      lastCapture: "",
      totalCapture: "",
      platform: "",
      subscriptionStatus: "",
    };

    // const extraData = data?.map((item) => {
    //   return { ...item, ...extraObjData };
    // });

    setData(dataRes);
    const { pageSize, totalRecords } = response || {};

    setPagination({
      pageSize: pageSize || 50,
      totalRecords,
      current: page,
    });
  }

  useEffect(() => {
    if (strikerId) {
      setShowUserSubscDetailModal(true);
    }
  }, []);

  useEffect(() => {
    getUsers({
      page: pagination.current,
      size: pagination.pageSize,
      order: "",
      name: "",
      search: deboucedSearch,
    });
  }, [deboucedSearch]);

  // const { data: userData, isLoading: userDataLoading } =
  //   UseApiCallForOldDashboardData({
  //     url: "get_all_users",
  //     method: "POST",
  //     body: {
  //       page: 1,
  //       size: 20,
  //     },
  //   });

  // if (userData) {
  //   console.log({ userData });
  // }

  const handleBeforeChange = (from, to) => {
    setCurrentSlide(to);
  };

  const handlePrev = () => sliderRef?.current?.goTo(0);

  const handleNext = () => sliderRef?.current?.next();

  // const fetchData = async (currentPage, pageSize) => {
  //   setLoading(true);
  //   const payload = deboucedSearch
  //     ? {
  //         page: currentPage,
  //         pageSize: pageSize,
  //         search: deboucedSearch,
  //       }
  //     : {
  //         page: currentPage,
  //         pageSize: pageSize,
  //       };
  //   try {
  //     const response = await axios.post(
  //       "https://bowg0wsg5k.execute-api.eu-central-1.amazonaws.com/prod/api/motion2coach/cv/user/subscription/details",
  //       payload,
  //       {
  //         headers: {
  //           Authorization:
  //             "bearer bde14d5ef15ef9f2189e1db876c004907ac857f85976f95d1e3effd350bf60e9",
  //         },
  //       }
  //     );
  //     const data = response?.data?.data?.users[0];
  //     const extraObjData = {
  //       role: "",
  //       lastCapture: "",
  //       totalCapture: "",
  //       platform: "",
  //       subscriptionStatus: "",
  //     };

  //     const extraData = data?.map((item) => {
  //       return { ...item, ...extraObjData };
  //     });
  //     setData(extraData);

  //     setPagination({
  //       ...response?.data?.data?.pagination,
  //       current: currentPage,
  //     });
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchData(pagination?.current, pagination?.pageSize);
  // }, [deboucedSearch]);
  const navigate = useNavigate();

  function displayAction(text, record, index) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", cursor: "pointer" }}
        className={styles.action}
        onClick={() => {
          navigate(`/m2c-analytics`);
          setUserInfo({
            userId: record?.id,
            username: record?.firstName,
            userEmail: record?.email,
          });
          setShowUserSubscDetailModal(true);
        }}
      >
        <img
          src="./assets/icons/eye.svg"
          alt="Icon"
          //   onClick={() => handlePreviewClick(record)}
        />
      </div>
    );
  }

  const columns = userListColumns?.map((state) => {
    if (state?.title === "Action") {
      return { ...state, render: displayAction };
    }

    if (state?.title === "ID") {
      return {
        ...state,
        render: (text, record, index) => {
          const globalIndex =
            ((pagination?.current || 1) - 1) * 100 + index + 1;
          return index < 9 && pagination?.current === 1
            ? `0${index + 1}`
            : globalIndex;
        },
      };
    }

    return { ...state, align: "left" };
  });

  const handleTableChange = (pagination, filters, sorter) => {
    // console.log({ pagination, filters, sorter });
    const { order, field } = sorter;
    const orderSort = order ? (order === "ascend" ? "asc" : "desc") : "";

    getUsers({
      page: pagination.current,
      size: pagination?.pageSize,
      name: order ? field : "",
      order: orderSort,
      search: deboucedSearch,
    });
  };
  // const handleTableChange = (pagination) => {
  //   fetchData(pagination?.current, pagination?.pageSize);
  // };

  function handleClickAddUser() {
    setOpenAddUser(true);
  }

  function handleCancel() {
    setOpenAddUser(false);
  }

  return (
    <section
      className={styles.userListContainer}
      style={{ height: maxHeight + "px" }}
    >
      <ConditionalRenderer condition={currentSlide === 0}>
        <NextIcon className={styles.nextIcon} onClick={handleNext} />
      </ConditionalRenderer>
      <ConditionalRenderer condition={currentSlide === 1}>
        <PreviousIcon className={styles.previousIcon} onClick={handlePrev} />
      </ConditionalRenderer>

      <Carousel
        dots={false}
        ref={sliderRef}
        infinite={false}
        className={styles.carouselContainer}
        beforeChange={handleBeforeChange}
      >
        <div>
          <div className={styles.userListHeader}>
            <div className={styles.titleContainer}>
              <UsersListIcon />
              <h2>Users List</h2>
            </div>
            <div className={styles.addAndSearch}>
              <div className={styles.inputContainer}>
                <SearchIcon />
                <input
                  type="text"
                  value={userSearch}
                  placeholder="Search here..."
                  onChange={(e) => {
                    setPagination({
                      ...pagination,
                      current: 1,
                    });
                    setUserSearch(e.target.value);
                  }}
                />
              </div>
              <AddUserIcon onClick={handleClickAddUser} />
            </div>
          </div>
          <Table
            columns={columns}
            className={styles.userListTable}
            scroll={{
              y: `${maxHeight - 160}px`,
            }}
            dataSource={data}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.totalRecords,
              showSizeChanger: false,
              position: ["bottomCenter"],
            }}
            loading={isLoading}
            onChange={handleTableChange}
          />
        </div>
        <GeographicalUserInsights />
      </Carousel>

      <Modal
        open={openAddUser}
        onCancel={handleCancel}
        footer={null}
        width={"90dvw"}
        destroyOnClose={true}
        className={styles.addUserModal}
        centered
      >
        <AddUserModalV2
          getUsers={getUsers}
          closeModal={handleCancel}
          page={pagination.current}
          size={pagination.pageSize}
          search={deboucedSearch}
        />
      </Modal>
      <ConditionalRenderer condition={showUserSubscDetailModal}>
        <UserDetailModalV2
          userId={strikerId || userInfo?.userId}
          showUserSubscDetailModal={showUserSubscDetailModal}
          handleCloseModal={handleCloseModal}
          getUsers={getUsers}
          page={pagination.current}
          size={pagination.pageSize}
          search={deboucedSearch}
          strikerId={strikerId}
        />
      </ConditionalRenderer>
    </section>
  );
}
